/**
 * Copyright 2016 Taito United Oy
 * All rights reserved.
 */

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import FaLaptop from 'react-icons/lib/fa/laptop';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { toTitleCase } from '~services/utils'; // eslint-disable-line

// Components
import CompanyInfo from './CompanyInfo';
import ReportHeader from './ReportHeader';
import Box, { Minifiable } from '../../components/Box';
import Button from '../../components/Button';

// Messages
import messages from './messages/ReportPaidHeader_messages';

const propTypes = {
  companyLocalities: PropTypes.array.isRequired,
  hasPiaced: PropTypes.bool,
  locale: PropTypes.object,
  report: PropTypes.object.isRequired,
  savePiace: PropTypes.func,
  showPortfolio: PropTypes.bool,
};

const defaultProps = {
  hasPiaced: true,
  locale: 'fi',
  savePiace: () => {},
  showPortfolio: false,
};

class ReportPaidHeader extends Component {
  state = {
    listState: {
      alternativeNames: false,
    },
  };

  savePiace = () => {
    this.props.savePiace({
      country: this.props.report.country,
      identifier: this.props.report.identifier,
    });
  };

  get brochureButton() {
    const {
      report: {
        identifier,
        portfolio_hidden: portfolioHidden,
      },
      showPortfolio,
    } = this.props;

    if (showPortfolio && !portfolioHidden) {
      return (
        <Button
          as='a'
          badge
          href={`/selvitys/esite/FI/${identifier}`}
          rel='noopener noreferrer'
          target='_blank'
          type='success'
        >
          <FormattedMessage
            {...messages.checkoutBrochure}
            info='Check out brochure'
          />
          <BrochureIcon />
        </Button>
      );
    }
    return null;
  }

  get logo() {
    const {
      report: {
        logo_id: logoId,
        names: { primary: name },
      },
    } = this.props;

    if (logoId) {
      return <Image src={`/api/images/${logoId}`} alt={name} />;
    }
    return null;
  }

  render() {
    const {
      companyLocalities,
      hasPiaced,
      locale,
      report,
    } = this.props;

    return (
      <Box
        headerLabel={<FormattedMessage { ...messages.header } />}
        id="statement-section-description"
      >

        <ReportHeader
          hasPiaced={hasPiaced}
          partners={report.partners}
          piaceCount={report.piace_count}
          savePiace={this.savePiace}
        />

        <CompanyInfo
          companyLocalities={companyLocalities}
          locale={locale}
          paidFeatures
          report={report}
        >
          {({
            auxiliaryNames,
            industry,
            keywords,
            localities,
            marketingName,
            primaryName,
          }) => (
            <CompanyPromo>
              <Info>
                {primaryName}
                {marketingName}
                {industry}

                <Minifiable>
                  {auxiliaryNames}
                  {localities}
                  {keywords}
                </Minifiable>
              </Info>

              <Logo>
                {this.logo}
                {this.brochureButton}
              </Logo>
            </CompanyPromo>
          )}
        </CompanyInfo>

        <About>{report.about}</About>
      </Box>
    );
  }
}

ReportPaidHeader.propTypes = propTypes;
ReportPaidHeader.defaultProps = defaultProps;

const About = styled.p`
  margin: 0;
  padding: 0;
`;

const BrochureIcon = styled(FaLaptop)`
  font-size: ${props => props.theme['font-size-xlarge']};
  line-height: ${props => props.theme['line-height-xlarge']};
  margin-left: 6px;
`;

const CompanyPromo = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: 720px) {
    flex-direction: row;
  }
`;

const Image = styled.img`
  margin-bottom: 24px;
  max-height: 150px;
  max-width: 250px;
`;

const Info = styled.div`
  flex: 2;
`;

const Logo = styled.div`
  align-items: flex-start;
  display: flex;
  flex: 1;
  flex-direction: column;
  margin-bottom: 12px;

  @media (min-width: 720px) {
    align-items: center;
  }
`;

export default ReportPaidHeader;
